import { render, staticRenderFns } from "./CoachManage.vue?vue&type=template&id=25490808&scoped=true"
import script from "./CoachManage.vue?vue&type=script&lang=js"
export * from "./CoachManage.vue?vue&type=script&lang=js"
import style0 from "./CoachManage.vue?vue&type=style&index=0&id=25490808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25490808",
  null
  
)

export default component.exports